import { TrayScreen } from '@/components/atoms/Tray/interfaces/Tray';
import Tray from '@/components/atoms/Tray/Tray';
import {
  TrayNavigationProvider,
  useTrayNavigation,
} from '@/components/providers/common/TrayNavigationProvider';
import { TransactionInterface } from '@/interfaces/TransactionInterface';
import { FC, useEffect } from 'react';
import TransactionDetailTrayBodyContent from './TransactionDetailTrayBodyContent';
interface TransactionDetailTrayProps {
  isTrayOpen: boolean;
  setIsTrayOpen: (isOpen: boolean) => void;
  transaction: TransactionInterface;
}
const TransactionDetailTrayContent: FC<TransactionDetailTrayProps> = ({
  isTrayOpen,
  setIsTrayOpen,
  transaction,
}) => {
  const { navigateBack } = useTrayNavigation();
  const closeTray = () => {
    setIsTrayOpen(false);
  };
  useEffect(() => {
    if (!isTrayOpen) {
    }
  }, [isTrayOpen]);
  const handleNavigateBack = () => {
    navigateBack();
  };
  const screens: [TrayScreen] = [
    {
      content: <TransactionDetailTrayBodyContent transaction={transaction} />,
      onNavigateBack: handleNavigateBack,
      title: 'Transaction',
    },
  ];
  return <Tray isOpen={isTrayOpen} onClose={closeTray} screens={screens} />;
};
const TransactionDetailTray: FC<TransactionDetailTrayProps> = (props) => (
  <TrayNavigationProvider>
    <TransactionDetailTrayContent {...props} />
  </TrayNavigationProvider>
);
export default TransactionDetailTray;
